import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

/**
 * A hairline. Hand-written rather than `@radix-ui/react-separator`, which would be a
 * package for twelve lines — CLAUDE.md §9's "no dead tooling" cuts both ways.
 *
 * `role="none"` because a decorative rule in a nav list is not a semantic separator, and
 * announcing it adds nothing a sighted reader gets either.
 */
export type SeparatorProps = ComponentProps<'div'> & {
  orientation?: 'horizontal' | 'vertical';
};

export const Separator = ({ className, orientation = 'horizontal', ...props }: SeparatorProps) => (
  <div
    role="none"
    className={cn('shrink-0 bg-border', orientation === 'vertical' ? 'h-full w-px' : 'h-px w-full', className)}
    {...props}
  />
);
